"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcText = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M3.61133 13H5.21777L6.11328 10.334H9.88672L10.7754 13H12.3887L8.82715 3.13574H7.17285L3.61133 13ZM7.93848 4.86523H8.05469L9.47656 9.10352H6.52344L7.93848 4.86523Z" }) })));
exports.default = IcText;
